'use strict';

// =============== Carousel Product ================= //
(function () {

    var carouselProducts = document.querySelectorAll('.carousel-products');

    if (carouselProducts.length) {

        carouselProducts.forEach(function (container) {

            var carousel = container.querySelector('.swiper-container');
            var carouselItemNumber = container.getAttribute('data-perview');
            var carouselProductSpacing = container.getAttribute('data-spacing');

            // Select swiper buttons relative to container to prevent all swiper to move at same time
            var next = container.querySelector('.swiper-button-next');
            var prev = container.querySelector('.swiper-button-prev');

            var slides = carousel.querySelectorAll('.carousel-item');

            // Add transition delay on each slide for fadein animation
            slides.forEach(function (slide) {
                slide.querySelector('.product-card').style.transitionDelay = slide.getAttribute('data-delay') + 's';
            });

            var mySwiper = new Swiper(carousel, {
                direction: 'horizontal',
                speed: 500,
                spaceBetween: parseInt(carouselProductSpacing),
                slidesPerView: 1.5,
                autoplay: {
                    delay: 3500
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3,
                        allowTouchMove: false
                    },
                    1200: {
                        slidesPerView: parseInt(carouselItemNumber),
                        allowTouchMove: false
                    }
                },
                on: {
                    init: function init() {
                        // Add custom class when slider is initialized and is in viewport or above
                        window.addEventListener('scroll', initCarousel);
                        initCarousel();
                    }
                }
            });

            // Stops autoplay when mouseenter
            carousel.addEventListener('mouseenter', function () {
                mySwiper.autoplay.stop();
            });

            // Start autoplay when mouseout
            carousel.addEventListener('mouseleave', function () {
                mySwiper.autoplay.start();
            });

            function initCarousel() {
                var scroll = window.pageYOffset + window.innerHeight / 1.4;
                var top = carousel.getBoundingClientRect().top + document.documentElement.scrollTop;
                if (top <= scroll) {
                    carousel.classList.add('is-initialized');
                }
            }
        });
    }
})();
"use strict";
"use strict";
"use strict";
"use strict";
"use strict";
'use strict';

function gridItemImageSwatches() {

          var products = document.querySelectorAll('.product-card');

          // Checks if page has product card elements
          if (!products || !products.length) {
                    return;
          }

          products.forEach(function (product) {

                    // Stores default product image
                    var defaultImage = product.querySelector('.grid-view-item__image-wrapper img');
                    var link = product.querySelector('.grid-view-item__link');

                    // Wait for it's image to be loaded before creating bindings
                    // Pass once as parameter to prevent retrigger of load event listener
                    defaultImage.addEventListener('load', function (e) {

                              var swatches = product.querySelectorAll('.grid-view-item__swatches .grid-view-item__swatches-item');

                              if (!swatches) {
                                        return;
                              }

                              swatches.forEach(function (swatch) {

                                        // Change the default image src for the selected variant src
                                        swatch.addEventListener('click', function () {
                                                  defaultImage.srcset = swatch.getAttribute('data-src');
                                                  link.href = swatch.getAttribute('data-href');
                                                  defaultImage.parentNode.classList.add('loading');
                                                  for (var i = 0; i < swatches.length; i++) {
                                                            swatches[i].classList.remove('selected');
                                                  }
                                                  swatch.classList.add('selected');
                                        });

                                        defaultImage.addEventListener('load', function () {
                                                  defaultImage.parentNode.classList.remove('loading');
                                        });
                              });

                              // Preload images - Todo if images are too long to load...

                              // const images = [];

                              // for (let i = 0; i < swatches.length; i++) {
                              //     images.push(swatches[i].getAttribute('data-src'));
                              // }

                              // const preloadImage = function (url) {
                              //     try {
                              //         var img = new Image();
                              //         img.src = url;
                              //     } catch (e) { }
                              // }

                              // async function preloadImages(){
                              //     // Preload a bunch of images in parallel
                              //     if(images.length){
                              //         await images.map(x => preloadImage(x.src));
                              //     }
                              // } 

                              // preloadImages();
                    }, { once: true });
          });
}gridItemImageSwatches();
'use strict';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else {
        obj[key] = value;
    }return obj;
}

$(document).ready(function () {
    var _2;

    // Carousel - Section Carousel

    var slideDuration = $('.carousel').data('slide-duration') * 1000;

    var swiperCarousel = new Swiper('.swiper-container.carousel', {
        parallax: true,
        effect: 'fade',
        speed: 1000,
        loop: true,
        autoplay: {
            delay: parseInt(slideDuration)
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });

    // Lorsque le carousel est initialisé, regarde si il y a des vidéo.
    swiperCarousel.on('init', function () {

        var currentVideo = $(this.$el).find('.swiper-slide-active video');
        var allVideo = $(this.$el).find('video');

        if (allVideo) {
            $(allVideo).each(function () {

                //Pause sur toutes les vidéos du carousel
                this.pause(this);
            });
        }

        if (currentVideo) {
            $(currentVideo).each(function () {

                //Play sur la vidéo du carousel actif
                this.play();
            });
        }
    });

    // Lorsque le carousel est change de slide, regarde si il y a des vidéo.
    swiperCarousel.on('slideChangeTransitionEnd', function () {

        var currentVideo = $(this.$el).find('.swiper-slide-active video');
        var allVideo = $(this.$el).find('video');

        if (allVideo) {
            $(allVideo).each(function () {

                //Pause sur toutes les vidéos du carousel
                this.pause(this);
            });
        }

        if (currentVideo) {
            $(currentVideo).each(function () {

                //Play sur la vidéo du carousel actif
                this.play();
            });
        }
    });

    // Carousel Sub-collections

    // Slide per view
    var subCollectionsPerView = $('.swiper-container.sub-collections-carousel').data('perview');

    var subCollections = new Swiper('.swiper-container.sub-collections-carousel', {
        speed: 1000,
        slidesPerView: 1.8,
        spaceBetween: 12,
        breakpoints: {
            1500: {
                spaceBetween: 30,
                slidesPerView: parseFloat(subCollectionsPerView)
            },
            1024: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 2.5
            }
        }
    });
});

// Carousel Bar annoncement

if ($(".announce-bar .swiper-slide").length >= 1) {
    var vautoplay = false;
    var vloop = false;
} else {
    var vloop = true;
    var vautoplay = {
        delay: 5000
    };
}
var AnnoucementBar = new Swiper('.announce-bar .swiper-container', {
    speed: 1000,
    loop: vloop,
    autoplay: vautoplay
});
"use strict";
'use strict';

/*=================== NAV ===================*/
$(document).ready(function () {

    /* ============== Animation delay NAV =============== */
    // Fait apparaître chaque item du menu dropdown avec un delais.
    // Le setTimeout est incrementé pour que le delai fonctionne peu importe le nombre de menus.
    /*$('body').on('mouseover', 'header .site-nav--has-dropdown', function () {
          var childLinks = $(this).find('.site-nav__dropdown .site-nav__childlist-item');
        var i = 0;
          $(childLinks).each(function (link) {
            var $this = this;
              setTimeout(function () {
                $($this).addClass('active');
            }, 50 * i);
            i++;
        });
    });
    $('body').on('mouseout', 'header .site-nav--has-dropdown', function () {
          var childLinks = $(this).find('.site-nav__dropdown .site-nav__childlist-item');
        var i = 0;
          $(childLinks).each(function (link) {
            var $this = this;
              setTimeout(function () {
                $($this).removeClass('active');
            }, 50 * i);
            i++;
        });
    });*/
    /* ============== Animation delay NAV - FIN =============== */

    /* ============== TOP SPACING =============== */

    if ($('.header-wrapper').length) {
        var topSpacing = $('.header-wrapper').outerHeight();

        $('body').css('cssText', 'padding-top:' + topSpacing + 'px; !important');
    }
    $(window).on('resize', function () {

        if ($('.header-wrapper').length) {
            var topSpacing = $('.header-wrapper').outerHeight();

            $('body').css('cssText', 'padding-top:' + topSpacing + 'px; !important');
        }
    });

    /* ============== TOP SPACING  - FIN =============== */

    /* ============== STICKY TOP HEADER =============== */

    var headerOffset = $('.header-wrapper').offset();

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {

            //Scrolling Down

            $('.header-wrapper').addClass('sticky');
            if ($('.utility-wrapper').length) {
                $('.header-wrapper').css('top', -$('.utility-wrapper').outerHeight());
            }
        } else {

            //Scrolling Top

            $('.header-wrapper').removeClass('sticky');

            var offset = $('.header-wrapper').offset();

            if (offset.top > 0) {
                if ($('.utility-wrapper').length) {
                    if ($('.utility-wrapper .announce-bar').length) {
                        $('.header-wrapper').css('top', -$('.utility-wrapper .announce-bar').outerHeight());
                    } else {
                        $('.header-wrapper').css('top', 0);
                    }
                }
            } else {
                if ($('.utility-wrapper').length) {
                    $('.header-wrapper').css('top', 0);
                }
            }
        }
        lastScrollTop = st;
    });

    /* ============== STICKY TOP HEADER - FIN =============== */
});
'use strict';

var heroScrollers = $('.hero-scroller');

$(heroScrollers).each(function () {

    var heroSelector = this;
    var overlaySelector = $(this).find('.overlay');
    var fadeSelector = $(this).find('.fade');

    var tl = new TimelineMax();
    var tl2 = new TimelineMax();
    var tl3 = new TimelineMax({ onUpdate: updatePercentage });
    var borderColor = $(overlaySelector).data('border');

    var controller = new ScrollMagic.Controller();

    tl.to(overlaySelector, 1, { boxShadow: "0px 0px 0px 0px " + borderColor + " inset" });
    tl3.to(heroSelector, 1, { boxShadow: "0px 0px 0px 0px " + borderColor + " inset" });

    var scene = new ScrollMagic.Scene({
        triggerElement: heroSelector,
        duration: "70%"
    }).setTween(tl).addTo(controller);

    scene.tweenChanges(true);

    var scene2 = new ScrollMagic.Scene({
        triggerElement: ".fade",
        duration: "100%",
        start: "0 center"
    }).setClassToggle(".fade", "active").addTo(controller).offset(-300);

    var scene3 = new ScrollMagic.Scene({
        triggerElement: heroSelector,
        duration: "100%"
    }).setTween(tl3).addTo(controller);

    function updatePercentage() {

        tl3.progress();
    }
});
"use strict";
"use strict";

/*
   *  render_map
   *
   *  This function will render a Google Map onto the selected jQuery element
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$el (jQuery element)
   *  @return	n/a
   */

function render_map($el) {

    // var
    var $markers = $el.find('.marker');
    var styles = [{
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
            "color": "#e9e9e9"
        }, {
            "lightness": 17
        }]
    }, {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{
            "color": "#f5f5f5"
        }, {
            "lightness": 20
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#ffffff"
        }, {
            "lightness": 17
        }]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#ffffff"
        }, {
            "lightness": 29
        }, {
            "weight": 0.2
        }]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{
            "color": "#ffffff"
        }, {
            "lightness": 18
        }]
    }, {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{
            "color": "#ffffff"
        }, {
            "lightness": 16
        }]
    }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
            "color": "#f5f5f5"
        }, {
            "lightness": 21
        }]
    }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
            "color": "#dedede"
        }, {
            "lightness": 21
        }]
    }, {
        "elementType": "labels.text.stroke",
        "stylers": [{
            "visibility": "on"
        }, {
            "color": "#ffffff"
        }, {
            "lightness": 16
        }]
    }, {
        "elementType": "labels.text.fill",
        "stylers": [{
            "saturation": 36
        }, {
            "color": "#333333"
        }, {
            "lightness": 40
        }]
    }, {
        "elementType": "labels.icon",
        "stylers": [{
            "visibility": "off"
        }]
    }, {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{
            "color": "#f2f2f2"
        }, {
            "lightness": 19
        }]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [{
            "color": "#fefefe"
        }, {
            "lightness": 20
        }]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{
            "color": "#fefefe"
        }, {
            "lightness": 17
        }, {
            "weight": 1.2
        }]
    }];

    var args = {
        scrollwheel: false,
        styles: styles,
        zoom: 17,
        disableDefaultUI: true,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    // create map
    var map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {

        add_marker($(this), map);
    });

    // center map
    center_map(map);
}

/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$marker (jQuery element)
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function add_marker($marker, map) {

    // var
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var myIcon = new google.maps.MarkerImage("/assets/ajax-loader.gif", null, null, null, new google.maps.Size(25, 27));

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: myIcon
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function () {

            infowindow.open(map, marker);
        });
    }
}

/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	map (Google Map object)
 *  @return	n/a
 */

function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(9);
    } else {
        // fit to bounds
        map.fitBounds(bounds);
    }
}

/*
 *  document ready
 *
 *  This function will render each map when the document is ready (page has loaded)
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	5.0.0
 *
 *  @param	n/a
 *  @return	n/a
 */

$(document).ready(function () {

    $('.shopify-map').each(function () {
        render_map($(this));
    });
});
'use strict';

$(document).ready(function () {

    $('select').not('.no-nice-select').niceSelect();

    var controller = new ScrollMagic.Controller();

    //STICKY FILTERS
    var sidebarHeight = $('.collection-left-column').height();
    var sidebarDuration = sidebarHeight - 500;

    var stickyFilters = new ScrollMagic.Scene({
        triggerElement: ".collection-left-column",
        duration: sidebarDuration,
        offset: 300
    }).setPin(".cloud-search-filters-sidebar-container").addTo(controller);

    var sidebarHeightMobile = $('.collection-holder-filtered').height();
    var sidebarDurationMobile = sidebarHeightMobile;
    var headerMobileHeight = ($('.site-header').height() + 15) * -1;

    var stickyFilters = new ScrollMagic.Scene({
        triggerElement: ".collection-holder-filtered",
        duration: sidebarDurationMobile,
        offset: headerMobileHeight
    }).triggerHook(0).setPin(".mobile-filters-trigger", { pushFollowers: false }).addTo(controller);

    //SELECT VARIATION ON RADIO CLICK
    $('input[type=radio][name=product-variation-id]').change(function () {
        var value = $(this).val();
        $("select[id]").val(value);
    });

    $('.variants-button-lists li').click(function () {
        var value = $(this).data('value');
        var targetParent = $(this).data('target-parent');
        var target = $(this).data('target');

        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');

        $(targetParent).val(value).change();

        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var productID = urlParams.get('variant');

        $('.product-single__sku strong').text(getCurrentSku(productID));
    });

    function getCurrentSku(value) {
        var globalProduct = $('#ProductJson-product-template').html();
        globalProduct = JSON.parse(globalProduct);

        for (var i = 0; i < globalProduct.variants.length; i++) {

            if (globalProduct.variants[i].id == value) {
                return globalProduct.variants[i].sku;
            }
        }
    }

    /*  $('.variants-button-lists li').click(function() {
      let value = $(this).data('value');
      let targetParent = $(this).data('target-parent');
      let target = $(this).data('target');
        console.log(targetParent, target);
        $(targetParent).val(value);
    }); */

    //OPEN INFOS TABS IN SINGLE PRODUCT
    $('.product-infos .tabs .tab .tab-head').click(function () {
        var currentTab = $(this).parent();
        $('.product-infos .tabs .tab').not(currentTab).find('.tab-content').slideUp();
        $('.product-infos .tabs .tab').not(currentTab).removeClass('active');

        currentTab.find('.tab-content').slideToggle();
        currentTab.toggleClass('active');
    });

    //STICKY CART SUMMARY
    if ($(window).width() >= 992) {
        var cartSummaryColHeight = $('.cart-summary-wrapper').height();
        var cartSummaryHeight = $('.cart__footer').innerHeight();
        var cartSummaryDuration = cartSummaryColHeight - cartSummaryHeight;

        var stickyCartSummary = new ScrollMagic.Scene({
            triggerElement: ".collection-left-column",
            duration: cartSummaryDuration
        }).setPin(".cart__footer").addTo(controller);
    }

    //POPUP
    if ($('.size-popup').length) {
        if ($('.size-popup').data('type') == "popup") {

            $('.size-popup').click(function (e) {
                e.preventDefault();

                $('.popup-container').addClass('active');
                $('.popup-container').removeClass('closed');
                $('body, html').addClass('no-scroll');
            });

            $('.popup-container').find('.popup-close').click(function () {

                $('.popup-container').removeClass('active');
                $('.popup-container').addClass('closed');
                $('body, html').removeClass('no-scroll');
            });
        }
    }

    /*
        var current_language = gt_get_cookie('googtrans').split('/').pop();
     console.log(current_language);
         if(!current_language){
         $('.language-selector a.en').css('display', 'inline-block');
         $('.language-selector a.fr').css('display', 'none');
       }
       else if(current_language == 'en'){
         $('.language-selector a.en').css('display', 'none');
         $('.language-selector a.fr').css('display', 'inline-block');
       }
       //Tranlate selector
     $('body').on('click', '.language-selector a', function(){
         current_language = gt_get_cookie('googtrans').split('/').pop();
         if(!current_language){
         $('.language-selector a.en').css('display', 'inline-block');
         $('.language-selector a.fr').css('display', 'none');
       }
       else{
         $('.language-selector a.en').css('display', 'none');
         $('.language-selector a.fr').css('display', 'inline-block');
       }
       });
       // W3 Schools: https://www.w3schools.com/js/js_cookies.asp
     function gt_get_cookie(cname) {
       var name = cname + "=";
       var decodedCookie = decodeURIComponent(document.cookie);
       var ca = decodedCookie.split(';');
       for(var i = 0; i <ca.length; i++) {
           var c = ca[i];
           while (c.charAt(0) == ' ') {
               c = c.substring(1);
           }
           if (c.indexOf(name) == 0) {
               return c.substring(name.length, c.length);
           }
       }
       return "";
     }
      */

    $('.variants-color-lists li').click(function () {
        var dataValue = $(this).attr('data-value');

        console.log(dataValue);

        $(this).parent().parent().parent().parent().find('.label-value').html(' - <strong>' + dataValue + '</strong>');
    });
});